(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rain-effect"] && !Shopify.designMode) return;
  try {
    
const rainContainer = document.getElementById("rain-container");

  function createRaindrop() {
    const drop = document.createElement("div");
    drop.classList.add("raindrop");

    // Random position across width
    drop.style.left = Math.random() * window.innerWidth + "px";

    // Random animation duration
    drop.style.animationDuration = 0.5 + Math.random() * 0.5 + "s";

    // Random size
    drop.style.height = 10 + Math.random() * 20 + "px";

    rainContainer.appendChild(drop);

    // Remove after animation
    setTimeout(() => {
      rainContainer.removeChild(drop);
    }, 1000);
  }

  // Create raindrops continuously
  setInterval(createRaindrop, 50);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
